import * as ConfigTypes from 'config/ConfigTypes';
import UIInput from 'components/UI/FormInput/FormInput';
import UIDropdown from "components/UI/Dropdown/Dropdown";
import UICheckBox from "components/UI/CheckBox/CheckBox";
import { getDropdownData } from "helpers/ConfigHelper";
import UIButton from "components/UI/Button/Button";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import UILoader from 'components/UI/Loader/Loader';
import DropdownWithInput from 'components/UI/DropdownWithInput/DropdownWithInput';
import InputDependsOnDD from 'components/UI/InputDependsOnDD/InputDependsOnDD';
import './Screen.scss';

const showReadOnly = (eObj) => {
    const { el, idx, isChild, fm, userInputs } = eObj;
    let text = userInputs[`${el.name}`] ? userInputs[`${el.name}`] : "";
    if (typeof text == 'object' && text.intl) {
        text = fm({ id: text.intl });
    }
    return (
        <div className="screen-readonly-row"
            key={`screen_text_${idx}`}>
            <label className={isChild && !el.isFirst ? 'screen-xs-label' : 'screen-label'}>
                {fm({ id: el.intl })}
            </label>
            <div className="screen-text">{text}</div>
        </div>
    )
}

const showText = (eObj) => {
    const { el, idx, isChild, fm, userInputs } = eObj;
    if (isChild) return "";
    let text = userInputs[`${el.name}`] ? userInputs[`${el.name}`] : "";
    if (typeof text == 'object' && text.intl) {
        text = fm({ id: text.intl });
    }
    if (el.type && el.type === ConfigTypes.TEXT_FROM_CHILDREN
        && el.children && el.children.length > 0
    ) {
        let all = el.children.map(child => userInputs[child.name]);
        if (all && all.length) text = all.join(" ");
    }
    return (
        <div className="screen-txt-row"
            key={`screen_text_${idx}`}>
            <label className="screen-label">
                {fm({ id: el.intl })}:
            </label>
            <div className="screen-text">
                <span>{text}</span>
            </div>
        </div>
    )
}

const showListData = (eObj) => {
    const { el, idx, fm } = eObj;
    let key = `screen_${el.name}${idx}${Date.now()}`;
    let data;
    if (el.data && el.data.length) {
        data = el.data.map(item => fm({ id: item.intl }));
    }
    if (data && data.length) {
        data = data.join(", ");
        return (
            <div className="screen-listdata" key={key}>
                - {fm({ id: el.intl })}: {data}
            </div>
        )
    }

    if (el.displayIntl) {
        return (
            <div className="screen-listdata" key={key}>
                - {fm({ id: el.displayIntl })}
            </div>
        )
    }
}

const showLinkData = (eObj) => {
    const { el, idx, fm } = eObj;
    let key = `screen_${el.name}${idx}${Date.now()}`;
    return (
        <div className="screen-linkdata" key={key}>
            <a className="screen-link" href={el.txtLinkUrl} target="_">
                {fm({ id: el.displayIntl })}
            </a>
        </div>
    )
}

const showInfo = (eObj) => {
    const { el, idx, fm } = eObj;
    let key = `screen_${el.name}${idx}`;
    return (
        <div className={`screen-info ${el.htmlClasses && el.htmlClasses}`} key={key}>
            {fm({ id: el.intl })}
        </div>
    )
}

const showInput = (eObj) => {
    const { el, idx, type, isChild, fm, onInput, userInputs, errors, addClasses, flexClasses } = eObj;
    let inputType = type;
    if (!type && el.type && el.type === ConfigTypes.PASSWORD) inputType = el.type;
    return (
        <UIInput name={el.name} key={`screen_input_${idx}`} type={inputType}
            isChild={isChild && !el.isFirst} label={fm({ id: el.intl })}
            value={userInputs[`${el.name}`] || ""} readOnly={el.readOnly}
            error={errors[`${el.name}`]} placeholder={fm({ id: el.intl })}
            plus={el.plus} addClasses={addClasses} flexClasses={flexClasses}
            check={el.check} isOne={isChild === 1} el={el}
            onChange={(e) => onInput(e, el.name)} required={el.required} />
    )
}

const showButton = (eObj) => {
    const { el, idx, fm, onBtn } = eObj;
    let htmlClasses = "screen-btn-box ";
    if (el.htmlClass) htmlClasses += el.htmlClass;
    let mode = el.screenMode ? el.screenMode : el.authForm;
    return (
        <div className={`screen-row ${el.noBuff && 'screen-row-nobuff'} `}
            key={`screen_btn_${idx}${el.name}`}>
            {!el.noBuff && <div className="screen-buff" />}
            <div className={htmlClasses}>
                <UIButton textOnly onClick={onBtn(mode)}
                    className="screen-button">
                    {el.icon && <FontAwesomeIcon icon={el.icon} />}
                    {fm({ id: el.intl })}
                </UIButton>
            </div>
        </div>)
}

const showDropdown = (eObj) => {
    const { el, idx, fm, onDDCk, dataObjects, userInputs, errors } = eObj
    let data = getDropdownData({ item: el, viewMode: ConfigTypes.REGISTER_INST });
    if (!data || !data.length) {
        if (dataObjects[el.originalname]) {
            let defaultXX = `${ConfigTypes.XX}${el.originalname}`;
            data = [{
                name: defaultXX, value: defaultXX,
                intl: fm({ id: `data.dropdown.${el.name}` })
            }];
            for (let i in dataObjects[el.originalname]) {
                let option = dataObjects[el.originalname][i][el.field];
                if (option) data.push({ name: i, value: option, option: option });
            }
        }
    }
    let classes = `screen-row screen-row-nobuff`;
    if (el.withLabel) classes = "screen-dd-row";
    return (
        <div className={classes}
            key={`screen_dropdown_${idx}${el.name}`}>
            {el.withLabel && (
                <label className="screen-label">
                    {el.intl ? fm({ id: el.intl }) : null}
                    {el.required && (
                        <span className="screen-required">
                            <FontAwesomeIcon icon={faStar} />
                        </span>
                    )}
                </label>
            )}
            {/* {!el.noBuff && <div className="screen-buff" />} */}
            {/* <UIDropdown data={data} current={userInputs[`${el.name}`] || ''}
                required={el.required} error={errors[`${el.name}`]} withLabel={el.withLabel}
                onDDClick={onDDCk(el)} /> */}
            <div className="screen-dd-box">
                <div className="screen-required-wrapper">
                    {(el.required) && <FontAwesomeIcon icon={faStar} />}
                </div>
                <DropdownWithInput
                    data={data} current={userInputs[`${el.name}`] || ''} withLabel={el.withLabel}
                    onDDClick={onDDCk(el)} required={el.required} error={errors[`${el.name}`]} />
            </div>
        </div>)
}

const showBreakLine = (eObj) => {
    const { idx, el } = eObj;
    return (
        <div className="screen-breakline-box"
            key={`screen_breakline_${idx}`}>
            <div className={!el.noLine && 'screen-breakline'} />
        </div>)
}

export const showCheckbox = (eObj) => {
    const { el, idx, fm, onCheckBox, userInputs, errors } = eObj;
    let label = fm({ id: el.intl });
    if (el.txtWithLink) {
        label = <span className="screen-link">
            {fm({ id: el.intl })}
            <a href={el.txtLinkUrl} target="_">{fm({ id: el.txtWithLink })}</a>
            {el.txtLinkAddTo && fm({ id: el.txtLinkAddTo })}
        </span>
    }
    return (
        <UICheckBox el={el} onCbChange={onCheckBox(el)}
            key={`screen_cb_${el.name}${idx}${el.name}`}
            isChecked={userInputs[`${el.name}`] || false}
            htmlClasses={el.htmlClasses}
            required={el.required} error={errors[`${el.name}`]}
            label={label} cbLeft={el.cbLeft} />
    )
}

export const showSplitContent = (eObj) => {
    const { el, idx } = eObj;
    if (el.children && el.children.length > 0) {
        return (
            <div className="screen-split-box" key={`screen_split${el.name}${idx}`}>
                {el.children.map((child, k) => (
                    <div className={`screen-split-column ${child.htmlClasses && child.htmlClasses}`}
                        key={`screen-split-${idx}${el.name}${k}`}
                    >
                        {child.children
                            && child.children.map((entry, index) => showElement({ ...eObj, el: entry, idx: index }))}
                    </div>
                ))}
            </div>)
    }
}

export const showCollapse = (coObj) => {
    const { el, idx, showContent, boxData, formatMessage, isActive, onBtn, boxState } = coObj;
    return (
        <div className="screen-collapse-box" key={`screen_collpase_${idx}${el.name}`}>
            <div className="screen-collapse-top">
                {el.children && el.children.map(x => {
                    let mode = x.screenMode ? x.screenMode : x.authForm;
                    return (
                        <UIButton textOnly onClick={onBtn(mode)}
                            className={`screen-button ${isActive == mode && 'screen-active'}`}>
                            {formatMessage({ id: x.intl })}
                        </UIButton>
                    )
                })}
            </div>
            <div className="screen-collapse-content">
                <div className={`${boxState ? 'screen-opened' : 'screen-collapse'}`}>
                    {showContent(boxData)}
                </div>
            </div>
        </div>
    )
}

export const showActions = (aObj) => {
    const { actions, onActionClick, userInputs, formatMessage, loading, msg } = aObj;
    return (
        <div className="screen-actions">
            <div className="screen-actions-msg">
                {/* {handleMsg({ msg, formatMessage })} */}
            </div>
            <div className="screen-actions-btn">
                {actions && actions.map((action, idx) => (
                    <div className="screen-btn-wrapper" key={`screen_actions_${action.name}${idx}`}>
                        <UIButton className={`screen-button ${action.isLarge && 'screen-xl-btn'}`}
                            textOnly
                            onClick={() => onActionClick({ action: action.name, userInputs })} >
                            {action.icon && (
                                <span className="screen-btn-icon">
                                    <FontAwesomeIcon icon={action.icon} />
                                </span>
                            )}
                            {formatMessage({ id: action.intl })}
                        </UIButton>
                        {(action.loader) && (
                            <div className="screen-loading">
                                {loading && <UILoader />}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    )
}


export const showElement = (eObj) => {
    if (eObj && eObj.el && eObj.el.type) {
        switch (eObj.el.type) {
            case ConfigTypes.BREAKLINE:
                return showBreakLine(eObj);
            case ConfigTypes.DROPDOWN:
                return showDropdown(eObj);
            case ConfigTypes.BTN:
                return showButton(eObj);
            case ConfigTypes.TEXT:
            case ConfigTypes.TEXT_FROM_CHILDREN:
                return showText(eObj);
            case ConfigTypes.READONLY:
                return showReadOnly(eObj);
            case ConfigTypes.INPUT:
            case ConfigTypes.PASSWORD:
                return showInput(eObj);
            case ConfigTypes.CHECKBOX:
                return showCheckbox(eObj);
            case ConfigTypes.SPLIT:
                return showSplitContent(eObj);
            case ConfigTypes.INFO:
                return showInfo(eObj);
            case ConfigTypes.LIST_DATA:
                return showListData(eObj);
            case ConfigTypes.LINK_DATA:
                return showLinkData(eObj);
            case ConfigTypes.INPUT_DEPENDS_ON_DD:
            case ConfigTypes.INPUT_DEPENDS_ON_DD_READONLY:
                return <InputDependsOnDD eObj={eObj} />
            default:
                return;
        }
    }
}